module.exports = __webpack_public_path__ + "src/img/zalando/img-perspective.57190.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-perspective.jpg
// module id = 264
// module chunks = 0